import {
	LOGO_ATELIER_ARGENTIQUE,
} from '../constants';

export class Loader {
	constructor() {
		this.loader = this.getLoaderDom();
	}

	getLoaderDom() {
		if (document.querySelector('.loader')) {
			return document.querySelector('.loader');
		}
		const loader = document.createElement('div');
		loader.className = 'loader hide';
		loader.innerHTML = `<div class="loader_logo_container"></div>`;
		return loader;
	}

	async insert() {
		if (!document.querySelector('.loader')) {
			const { default: logoAtelierArgentique } = await import(`icons/${LOGO_ATELIER_ARGENTIQUE}`);
			this.loader.querySelector('.loader_logo_container').innerHTML = logoAtelierArgentique;
			document.body.appendChild(this.loader);
		}
		return this;
	}

	show() {
		this.loader.classList.remove('hide');
		const subMenuOpen = document.querySelector('.subMenuOpen');
		if (subMenuOpen) subMenuOpen.classList.remove('subMenuOpen');
	}

	hide() {
		this.loader.classList.add('hide');
	}
}
